"use client";
import React, { useState } from "react";
import styled from "styled-components";
import { CardLogo, GreenTickImg, SubscriptionBgImg } from "../utils/Images"
import { Elements, CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";
import { Form } from "antd";
import { addpaymentmethod, createtrialsubscription } from "../collection/ApiCollection";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CheckoutForm = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const stripe = useStripe();
    const elements = useElements();
    const [loader, setLoader] = useState(false);
    const [asDefault, setAsDefault] = useState(false);
    const isSchedule = useSelector((state) => state?.Authlogin?.data?.userDetail?.isScheduled);
    
    const handleCreateTrial = async () => {
            let req = {
                type:"1"
            }
            try {
                let res = await createtrialsubscription(req);
                if (res.status === 200) {
                    toast.success(res?.message);
                } else {
                    toast.error(res?.data?.response?.data?.message || res?.data?.error || res?.data?.message || "Something went wrong")
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || error?.error || error?.message || "Something went wrong")
            }
        }

    const elementStyles = {
        style: {
            base: {
                backgroundColor: "#fff", // Set background color to white
                color: "#000", // Text color
                "::placeholder": {
                    color: "#aab7c4", // Placeholder text color
                },
            },
            invalid: {
                color: "#fa755a", // Error text color
            },
        },
    };

    const onFinish = async (values) => {
        if (asDefault) {
            if (!stripe || !elements) {
                console.error("Stripe.js has not loaded.");
                return;
            }

            const card = elements.getElement(CardNumberElement);
            if (!card) {
                //   message.error("Card element not found.");
                return;
            }

            setLoader(true);
            try {
                const { token, error } = await stripe.createToken(card, {
                    name: values.cardholderName,
                });

                if (error) {
                    setLoader(false);
                    toast.error(error.message || "Failed to create token.");
                    return;
                } else {
                    let req = {
                        paymentMethodToken: token?.id
                    }
                    let res = await addpaymentmethod(req)
                    if (res?.status === 200) {
                        toast.success(res?.message);
                        setLoader(false);
                        handleCreateTrial();
                        if (isSchedule) {
                            navigate(-1)
                        } else {
                            navigate("/landing/schedule")
                        }
                    } else {
                        setLoader(false);
                        toast.error(res?.response?.data?.message || res?.error || res?.message || "Something went wrong")
                    }
                    // if(res?.status === )
                }
            } catch (err) {
                console.error("Error during submission:", err);
                toast.error("An unexpected error occurred.");
            } finally {
                setLoader(false);
            }
        } else {
            toast.error("Please select set as default")
        }
    };

    return (
        <Background>
            <Title>
                You are one step away from your <span>30 days</span> free trial
            </Title>
            <Subtitle>We will only charge you after 30 days free trial</Subtitle>
            <div style={{ maxWidth: "700px", width:"100%" }}>
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <CardContainer>
                        <div className="card-heading">
                            <p><img src={GreenTickImg} alt="" width={24} height={24} />Add new card</p>
                            <img src={CardLogo} alt="" width={144} height={28} />
                        </div>
                        <Content>
                            <div className="card-number-div">
                                <div className="inner-div">
                                    <h1>Card number</h1>
                                    <p>Enter the 16-digit card number on the card</p>
                                </div>
                                <Form.Item
                                    label=""
                                    name="cardNumber"
                                    style={{ width: "100%" }}
                                >
                                    <StripeElementWrapper>
                                        <CardNumberElement options={elementStyles} />
                                    </StripeElementWrapper>
                                </Form.Item>
                            </div>
                            <div className="card-number-div">
                                <div className="inner-div">
                                    <h1>Card owner</h1>
                                    <p>Enter the name on the card</p>
                                </div>
                                <Form.Item
                                    label=""
                                    name="cardholderName"
                                    rules={[{ required: true, message: "Card owner name is required" }]}
                                    style={{ width: "100%" }}
                                >
                                    <div className="input-div">
                                        <input type="text" />
                                    </div>
                                </Form.Item>
                            </div>
                            <div className="card-number-div">
                                <div className="inner-div">
                                    <h1>Expiry date</h1>
                                    <p>Enter the expration date of the card</p>
                                </div>
                                <div className="multi-elements">
                                    <Form.Item
                                        label=""
                                        name="expireDate"
                                        style={{ width: "100%" }}
                                    >
                                        <StripeElementWrapper>
                                            <CardExpiryElement options={{ placeholder: "MM/YY" }} />
                                        </StripeElementWrapper>
                                    </Form.Item>
                                    <div className="cvv-div">
                                        <h1>CVV</h1>
                                        <p>Security code</p>
                                    </div>
                                    <Form.Item
                                        label=""
                                        name="cvv"
                                        style={{ width: "100%" }}
                                    >
                                        <StripeElementWrapper>
                                            <CardCvcElement options={{ placeholder: "CVC" }} />
                                        </StripeElementWrapper>
                                    </Form.Item>
                                </div>
                            </div>
                        </Content>
                    </CardContainer>
                    <CheckboxContainer>
                        <input type="checkbox" id="default" style={{ width: "24px", height: "24px" }} onChange={(e) => setAsDefault(e?.target?.checked)} />
                        <CheckboxLabel htmlFor="default">Set as default</CheckboxLabel>
                    </CheckboxContainer>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <Button type="submit">{loader ? "Loading..." : "Add Payment Method"}</Button>
                    </div>
                </Form>
            </div>
        </Background>
    );
};


export default CheckoutForm

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url(${SubscriptionBgImg});
  background-size: cover;
  background-position: center;
  filter: brightness(70%);
`;

const CardContainer = styled.div`
  background-color: transparent;
  max-width: 700px;
  width: 100%;
  border: 1px solid #CFCFCF;
  border-radius:16px;
  padding: 24px 32px;

  .card-heading{
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-bottom:24px;
    p{
        color:#fff;
        font-weight:500;
        font-size:16px;
        display:flex;
        align-items:center;
        gap:16px;
    }
  }
    .card-number-div{
        display:flex;
        gap:16px;

        @media (max-width: 763px){
            flex-direction: column;
        }

        .inner-div{
            max-width:240px;
            width:100%;
            h1{
                color:#fff;
                font-size:16px;
                font-weight:400;
                margin-bottom:4px;
                white-space:nowrap;
            }
            p{
                color:#C6C6C6;
                font-size:12px;
                font-weight:400;
                white-space:nowrap;
            }
        }
        .input-div{
            width:100%;
            input{
                width:100%;
                height:48px;
                border-radius:8px;
                background:#fff;
                padding: 0px 15px;
                border: 1px solid #CFCFCF;

                &:focus{
                    outline:none;
                }
            }
        }
        .multi-elements{
            width:100%;
            display:flex;
            gap:16px;

            @media (max-width: 430px){
                flex-direction: column;
            }

            .cvv-div{
                h1{
                    color:#fff;
                    font-weight:400;
                    font-size:16px;
                }
                p{
                    color:#C6C6C6;
                    font-size:14px;
                    font-weight:300;
                    margin-top:4px;
                    white-space:nowrap;
                }
            }
        }
    }
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin-bottom: 19px;

  span {
    color: #0DA982;
  }
`;

const Subtitle = styled.p`
  text-align: center;
  color: #fff;
  margin-bottom: 29px;
  font-size:19px;
  font-weight:400;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const StripeElementWrapper = styled.div`
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
  width:100%;
  background-color:#fff;

  &:focus-within {
    border-color: #2ecc71;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top:32px;
  margin-bottom:16px;
  max-width:700px;
  width:100%;
  justify-content:end;
`;

const CheckboxLabel = styled.label`
  font-size: 16px;
  font-weight:400;
  color: #fff;
`;

const Button = styled.button`
  background-color: #0DA982;
  color: #fff;
  border: none;
  border-radius: 15px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  height:48px;
  padding: 0px 29px;

  &:hover {
    background-color: #27ae60;
  }
`;